import React from 'react';
import { Trash2, FolderInput } from 'lucide-react';

const SessionCard = ({ session, onClick, onDelete, onMove, currentUser }) => {
  const handleDelete = (e) => {
    e.stopPropagation(); // Prevent card click when deleting
    if (window.confirm(`Are you sure you want to delete "${session.name}"? This cannot be undone.`)) {
      onDelete(session.id);
    }
  };

  const handleMove = (e) => {
    e.stopPropagation();
    onMove(session);
  };

  // Deletion is admin-only (facilitators can create sessions but not delete them). 
  const canDelete = currentUser.role === 'admin';
  const canMove = onMove && (currentUser.role === 'admin' || session.created_by === currentUser.id);

  return (
    <div
      className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow cursor-pointer relative group"
      onClick={onClick}
    >
      <div className="absolute top-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
        {canMove && (
          <button
            onClick={handleMove}
            className="p-2 text-gray-400 hover:text-[#01006A] rounded hover:bg-gray-100"
            title="Move to another workshop"
          >
            <FolderInput className="w-4 h-4" />
          </button>
        )}
        {canDelete && (
          <button
            onClick={handleDelete}
            className="p-2 text-gray-400 hover:text-red-600 rounded hover:bg-gray-100"
            title="Delete session"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        )}
      </div>

      <h3 className="text-lg font-semibold text-gray-900 mb-2">{session.name}</h3>
      <p className="text-sm text-gray-600 mb-4 line-clamp-2">{session.description}</p>
      <div className="flex items-center justify-between text-xs text-gray-500">
        <span>{session.uncertainties?.length || 0} uncertainties</span>
        <span>{Object.keys(session.votes || {}).length} votes</span>
      </div>
    </div>
  );
};

export default SessionCard;